const popup = {
  state: {
    visible: false,
    title: '알림',
    description: '',
    /** @type {Array<{ text: string, danger?: boolean }>|undefined} */
    descriptionParts: undefined,
    okText: '확인',
    cancelText: '취소',
    clickable: true,
    slot: undefined,
    okCallback: undefined,
    cancelCallback: undefined,
    closeCallback: undefined,
    showCancel: true,
    showOk: true,
  },
  getters: {
    visible: (state) => state.visible,
    title: (state) => state.title,
    description: (state) => state.description,
    descriptionParts: (state) => state.descriptionParts,
    okText: (state) => state.okText,
    cancelText: (state) => state.cancelText,
    clickable: (state) => state.clickable,
    slot: (state) => state.slot,
    okCallback: (state) => state.okCallback,
    cancelCallback: (state) => state.cancelCallback,
    closeCallback: (state) => state.closeCallback,
    showCancel: (state) => state.showCancel,
    showOk: (state) => state.showOk,
  },
  mutations: {
    setVisible: (state, payload) => (state.visible = payload),
    setTitle: (state, payload) => (state.title = payload),
    setDescription: (state, payload) => (state.description = payload),
    setDescriptionParts: (state, payload) => (state.descriptionParts = payload),
    setOkText: (state, payload) => (state.okText = payload),
    setCancelText: (state, payload) => (state.cancelText = payload),
    setClickable: (state, payload) => (state.clickable = payload),
    setSlot: (state, payload) => (state.slot = payload),
    setOkCallback: (state, payload) => (state.okCallback = payload),
    setCancelCallback: (state, payload) => (state.cancelCallback = payload),
    setCloseCallback: (state, payload) => (state.closeCallback = payload),
    setShowCancel: (state, payload) => (state.showCancel = payload),
    setShowOk: (state, payload) => (state.showOk = payload),
    init: (state) => {
      state.title = '알림';
      state.description = '';
      state.descriptionParts = undefined;
      state.okText = '확인';
      state.cancelText = '취소';
      state.clickable = true;
      state.slot = undefined;
      state.okCallback = undefined;
      state.cancelCallback = undefined;
      state.closeCallback = undefined;
      state.showCancel = true;
      state.showOk = true;
    },
  },
  actions: {
    show: (store, payload) => {
      store.commit('setOkCallback', payload?.okCallback ?? undefined);
      store.commit('setCancelCallback', payload?.cancelCallback ?? undefined);
      store.commit('setCloseCallback', payload?.closeCallback ?? undefined);
      if (payload?.title?.length > 0) {
        store.commit('setTitle', payload?.title);
      }
      if (Array.isArray(payload?.descriptionParts) && payload.descriptionParts.length > 0) {
        store.commit('setDescriptionParts', payload.descriptionParts);
        store.commit('setDescription', '');
      } else if (payload?.description?.length > 0) {
        store.commit('setDescriptionParts', undefined);
        store.commit('setDescription', payload?.description);
      }
      if (payload?.okText?.length > 0) {
        store.commit('setOkText', payload?.okText);
      }
      if (payload?.cancelText?.length > 0) {
        store.commit('setCancelText', payload?.cancelText);
      }
      if (payload?.clickable !== undefined) {
        store.commit('setClickable', payload?.clickable);
      }
      if (payload?.slot !== undefined) {
        store.commit('setSlot', payload?.slot);
      }
      if (payload?.showCancel !== undefined) {
        store.commit('setShowCancel', payload?.showCancel);
      }
      if (payload?.showOk !== undefined) {
        store.commit('setShowOk', payload?.showOk);
      }
      store.commit('setVisible', true);
    },
    hide: (store) => {
      store.commit('setVisible', false);
      store.commit('init');
    },
  },
};

export default popup;
